export const ROOT_API = process.env.VUE_APP_ROOT_API;
export const CORE_VERSION = process.env.VUE_APP_VERSION ?? process.env.$npm_package_version ?? '';
export const UPLOAD_SERVICE_API = process.env.VUE_APP_UPLOAD_SERVICE_URL;
export const DELINQUENCY_API = process.env.VUE_APP_DELINQUENCY_API;
export const DELINQUENCY_SOCKET = process.env.VUE_APP_DELINQUENCY_SOCKET;
export const LOAN_PRO_API = process.env.VUE_APP_LOAN_PRO_API;
export const DOC_PRO_ROOT_API = process.env.VUE_APP_DOC_PRO_API;
